import React from "react";
import "./startBattleFinalistWeekBtn.scss";

const StartBattleFinalistWeekBtn = ({
  onClick,
  style = {},
  className = "",
  disabled,
  text,
  icon: IconComponent,
  width,
}) => {
  const dynamicStyle = disabled
    ? { color: "black", cursor: "not-allowed" }
    : { color: "#b03a2e" };

  return (
    <button
      type="button"
      style={{ width, ...dynamicStyle, ...style }}
      className={`start-battle-finalist-week-btn ${className}`}
      onClick={onClick}
      disabled={disabled}
      aria-disabled={disabled ? "true" : "false"}
    >
      {IconComponent && (
        <span className="start-battle-finalist-week-btn-icon">
          <IconComponent fillColor={dynamicStyle.color} strokeColor={dynamicStyle.color} />
        </span>
      )}
      {text}
    </button>
  );
};

export default StartBattleFinalistWeekBtn;
